import { render } from "./Item2.vue?vue&type=template&id=64901b2e&ts=true"
import script from "./Item2.vue?vue&type=script&lang=ts"
export * from "./Item2.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__